//
import { ProductModel } from '@/models'

/**
 * 
 */
const fetchAll = async function () {

    //
    const includes = [ 'wh_products_promo' ]
        , appends  = [ 'sale_prices', 'composition', 'stocks', 'discounts', 'branch_offices' ]

    //
    try {

        //
        const product = await ProductModel.include( includes ).append( appends ).params({ get_all_results : true }).get()

        //
        return product.data
    } catch ( error ) {

        //
        return error.response.data
    }
}

//
export default fetchAll
